export const ReadMoreFlightLessons = () => {
    return (
        <div className="readMore">
            <p>
                During my freshman and sophomore year of high school, I started taking flight lessons towards getting my private pilot's license (PPL). In this time I amassed about a dozen hours in a Cessna 172, but unfortunately it was cut short by the COVID-19 pandemic. I still hope to get my PPL when I get the chance but in the meantime here is a photo of me landing at Princeton Airport (39N):
            </p>
            <img src="Princeton Airport Photo.jpg" alt="Landing at Princeton Airport during a flight lesson" />
            <br />
        </div>
    );
}